


import { Router,ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSortModule, MatSort, MatSortable } from '@angular/material/sort';
import { Component, OnInit, ViewChild, TemplateRef,ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import Swal from 'sweetalert2';
import { CollegeService, College_Names, Student_scheduleid } from '../services/College_name.service';
import { isEmpty } from 'lodash';
import { userDetailsService } from '../services/user.details.service';
import { report, ReportService } from '../services/report.service';



@Component({
  selector: 'evaluator-workbench.component',
  styleUrls: ['evaluator-workbench.component.scss'],
  templateUrl: 'evaluator-workbench.component.html',
})


export class EvaluatorWorkBench {
  displayedColumns: any[] = [];
  dataSource: MatTableDataSource<any>;
  SelectedQuestionSetId:any;
  studentDetails:any[] =[];
  // stickyColumns=['S.No.','Name','Total_Score','Actions','SelectAll']
  stickyColumns=['Name','Total_Score','Actions']
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  @ViewChild("pdfcontent") pdfContent: TemplateRef<any>;
  @ViewChild("completeEval") completeEval: TemplateRef<any>;
  report_details: report = { College_Id: '', Year_Id: '', Question_Set: '' };


  selectedCandidate: any;
  modalRef: any;
  isManualEvalChecked:boolean = false;
  isInterviewChecked:boolean = false;
  questionpdf: boolean;
  student_id:Student_scheduleid={user_id:'',schedule_id:''}
  scheduleid: any;
  rollnumber: any;
  firstname: any;
  college_name: any;
  imageUrl: any;
  imageUrlArray: any;
  studentdata: any;
  id: string;
  questions_ready: boolean;
  isSelectedForManualEval = false;
  isShortlistedForInterview = false;
  filteredDetails =[]
  College_Id: string;
  Year_Id: string;
  reportdetailss: any;
  disableManualEval = false;
  disableInterview = false;
  filteredIdsArray :any=[]
  College_Name: any;
  displayTable: boolean;
  isLoading= false;
  isEvaluated: any;
  disableToggle:boolean;
  selectedForManualEvalArray:any=[]
  options = [
    {value: 'All', viewValue: 'All'},
    {value: 'Selected for Manual Evaluation', viewValue: 'Selected for Manual Evaluation'},
    {value: 'Shortlisted for Interview', viewValue: 'Shortlisted for Interview'},
    {value: 'Evaluated', viewValue: 'Evaluated Candidates'},
  ];
  selectedOption:any='All'
  dataLength:any;
  disableManualEvalButton=false;
  private tableReady=false;



  constructor(private fs: CollegeService,private route: ActivatedRoute,
    private router: Router,private modal: NgbModal, private userDetails: userDetailsService,
    private reportservice: ReportService,) {}


  ngOnInit() {
    console.log("this.route.snapshot.params",this.route.snapshot.params)
    this.SelectedQuestionSetId = this.route.snapshot.params.Question_Set_Id;
    this.College_Id = this.route.snapshot.params.College_Id;
    this.Year_Id = this.route.snapshot.params.Year_Id;
    this.College_Name = this.route.snapshot.params.College_Name
    this.isLoading = true;
    this.isEvaluated = this.route.snapshot.params.isEvaluated
    this.disableToggle = this.isEvaluated == 'Pending' ? false :true
    console.log("disableToggle",this.disableToggle)
    console.log("SelectedQuestionSetId",this.SelectedQuestionSetId); // 'value1'
    this.getTableData();
    this.disableManualEvalButton = this.selectedForManualEvalArray.length == 0 ? true : false
    console.log("disableManualEvalButton",this.disableManualEvalButton)
  }

  ngAfterViewInit() {
    this.tableReady = true
  }

  getStyle(){
    console.log("inside getstyle")
    if(this.displayTable == true){
      return { 'margin-top': '-40px' }
    }else{
      return { 'margin-top': '15px' }
    }
  }

  getTableData(){
    this.fs.get_all_student_details(this.SelectedQuestionSetId,this.College_Id,this.Year_Id).subscribe(
      (data) => {
        console.log("data.results.length",data.results.length)
        this.dataLength = data.results.length;
        if(data.results.length == 0){
          console.log("insid 0")
          this.displayTable = false
          this.isLoading = false

        }else{
          if(this.tableReady == true){
            console.log("insdie tableReady true")
          this.displayTable = true
          this.studentDetails = data.results
          this.dataSource = new MatTableDataSource(this.studentDetails);
          console.log("this.datasoruce",this.dataSource)
          // setTimeout(() =>{this.isLoading = false})

          this.dataSource.sort = this.sort;
          this.dataSource.sort.sort(<MatSortable>({ id: 'Total_Score', start: 'desc' }));
          setTimeout(() => this.dataSource.paginator = this.paginator);
          this.isLoading = false
          console.log("this.studentDetails",this.studentDetails)
      
      
          console.log(" Object.keys(data[0])", Object.keys(this.studentDetails[0]))
  
          this.displayedColumns = Object.keys(this.studentDetails[0]);
          // this.displayedColumns.unshift('S.No.','MultiSelect')
          this.displayedColumns.unshift('MultiSelect')
          this.displayedColumns.push('Actions')
          for (let i=0;i<this.displayedColumns.length;i++) {
         
            if (this.displayedColumns[i] == 'Id') {
              this.displayedColumns.splice(i, 1);
            }
            if (this.displayedColumns[i] == 'Schedule_Id') {
              this.displayedColumns.splice(i, 1);
            }
         
          }

        }
      }
        console.log("displayedColumns",this.displayedColumns)

      },
      err => {
        console.error(err);
      }
    );
  }

  selectCandidatesForManualEvaluation(){
    this.fs.update_manualEvaluationFlag_in_schedule(this.selectedForManualEvalArray).subscribe(
      (data) => {
        console.log("inside update_manualEvaluationFlag_in_schedule")
        if (data.code === 200) {
          Swal.fire({
            title: 'Success',
            text: data.success,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
              return;
            }
          })
        } else if (data.code === 400) {
          Swal.fire({
            title: 'Alert',
            text: data.failed,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })

        }
        
      },
      err => {
        console.error(err);
      }
    );
  }

  toggleRowSelection(row) {
    console.log("togglerow",row)
    row.selected = !row.selected;
    console.log("row.selected",row.selected)
    console.log("this.disableManualEvalButton inside",this.disableManualEvalButton)
    if(row.selected == true){
    this.selectedForManualEvalArray.push(row.Id)
    }
    else{
    if(this.selectedForManualEvalArray.length > 0 && this.selectedForManualEvalArray.includes(row.Id) == true)
    this.selectedForManualEvalArray = this.selectedForManualEvalArray.filter(item => item !== row.Id);
    }
    this.disableManualEvalButton = this.selectedForManualEvalArray.length == 0 ? true : false

    console.log("this.selectedForManualEvalArray",this.selectedForManualEvalArray,this.selectedForManualEvalArray.length)
  }

  selectFilters(event: any, i: any) {
    const selectedValue = event.target.value; // Get the selected value
    console.log('Selected option:', selectedValue);
    this.selectedOption = selectedValue
    if(selectedValue == 'Selected for Manual Evaluation'){
      this.filteredDetails = []
      console.log("inside Selected for Manual Evaluation")
      for(let i=0;i<this.studentDetails.length;i++){
        if(this.studentDetails[i][`Selected for Manual Evaluation`] == 'Yes'){
          console.log("Selected for Manual Evaluation is yes")
          this.filteredDetails.push(this.studentDetails[i])
        }
      }
      console.log("this.filter",this.filteredDetails)
      this.updateDataSourceBasedOnFilter(this.filteredDetails)
    }else if(selectedValue == 'Shortlisted for Interview'){
      this.filteredDetails = []
      console.log("inside Shortlisted for Interview")

      for(let i=0;i<this.studentDetails.length;i++){
        if(this.studentDetails[i][`Shortlisted for interview`] == 'Yes'){
          console.log("Shortlisted for interview is yes")

          this.filteredDetails.push(this.studentDetails[i])
        }
      }
      console.log("this.filter",this.filteredDetails)
      this.updateDataSourceBasedOnFilter(this.filteredDetails)
    }else if(selectedValue == 'All'){
      this.updateDataSourceBasedOnFilter(this.studentDetails)
      this.filteredDetails = []
    }else if(selectedValue == 'Evaluated'){
      this.filteredDetails = []
      console.log("inside Evaluated")

      for(let i=0;i<this.studentDetails.length;i++){
        if(this.studentDetails[i][`Evaluated`] == 'Yes'){
          console.log("Evaluated is yes")

          this.filteredDetails.push(this.studentDetails[i])
        }
      }
      console.log("this.filter",this.filteredDetails)
      this.updateDataSourceBasedOnFilter(this.filteredDetails)
    }
    // Perform any other actions you want based on the selected value
  }
  
  

  openToggleModel(row){
    this.selectedCandidate = row
    this.isManualEvalChecked = row[`Selected for Manual Evaluation`] == 'Yes' ? true : false
    this.isInterviewChecked = row[`Shortlisted for interview`] == 'Yes' ? true : false
    console.log("inside ")
    if(this.isEvaluated == 'Pending'){
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modal.open(this.modalContent, ngbModalOptions)
  }
  }

  showWarning(){
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modal.open(this.completeEval, ngbModalOptions)
  }



  onChangeManualEval(event: MatSlideToggleChange) {
    const isChecked = event?.source?.checked;
    this.isManualEvalChecked = isChecked == true ? true : false
    console.log("this.isManualEvalChecked ",this.isManualEvalChecked )
    this.selectedCandidate[`Selected for Manual Evaluation`] = this.isManualEvalChecked == true ? 'Yes' : 'No';
  }
  

  onChangeInterview(event: MatSlideToggleChange) {
    const isChecked = event?.source?.checked;
    this.isInterviewChecked = isChecked == true ? true : false
    console.log("this.isManualEvalChecked ",this.isInterviewChecked )
    this.selectedCandidate[`Shortlisted for interview`] = this.isInterviewChecked == true ? 'Yes' : 'No';

  }


  closeToggleModal(){
    this.modalRef.close(this.modalContent)

  }

  completeEvaluation(){
    var params = {
      "Question_Set_Id":this.SelectedQuestionSetId,
      "College_Id":this.College_Id,
      "Year_Id":this.Year_Id,
      "Is_Evaluated":'Completed'
    }
    console.log("params",params)
    this.modalRef.close(this.completeEval)
    this.fs.update_isEvaluated_in_schedule_master(params).subscribe(
      (data) => {
        console.log("inside")
        if (data.code === 200) {
          Swal.fire({
            title: 'Success',
            text: data.success,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // window.location.reload();
              this.router.navigate(['test_evaluation'])
              return;
            }
          })
        } else if (data.code === 400) {
          Swal.fire({
            title: 'Alert',
            text: data.failed,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })

        }
        
      },
      err => {
        console.error(err);
      }
    );
  }

  saveToggledValue(){
    console.log("this.selectedcandidate",this.selectedCandidate)
    this.closeToggleModal()
    this.fs.update_flags_in_schedule(this.selectedCandidate).subscribe(
      (data) => {
        console.log("inside")
        if (data.code === 200) {
          // Swal.fire({
          //   title: 'Success',
          //   text: data.success,
          //   icon: 'success',
          //   showCancelButton: false,
          //   confirmButtonText: 'OK'
          // }).then((result) => {
          //   if (result.isConfirmed) {
          //     window.location.reload();
          //     return;
          //   }
          // })
        } else if (data.code === 400) {
          Swal.fire({
            title: 'Alert',
            text: data.failed,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })

        }
        
      },
      err => {
        console.error(err);
      }
    );
  }

  back() {
    this.router.navigate(['test_evaluation']);
  }

  downloadPdf(row){
    console.log("inisde download",row)
    this.student_id.user_id = row.Id;
    this.student_id.schedule_id = row.Schedule_id;
    sessionStorage.setItem('studentdata',JSON.stringify(this.student_id));

    this.questionpdf=true;
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modal.open(this.pdfContent, ngbModalOptions)
    this.view_questions(row);
  }

  view_questions(row) {
    console.log("inside view questions",row)
    // this.studentdata=JSON.parse(sessionStorage.getItem('studentdata'));
    this.student_id.user_id = row.Id;
    this.student_id.schedule_id = row.Schedule_Id;
    console.log("this.student_id*******",this.student_id)
    this.fs.Student_Schedule_Id(this.student_id).subscribe(
      (data) => {

        console.log("data**********",data)
        this.scheduleid = data.results;


        this.rollnumber = this.scheduleid[0].Roll_Number;
        if(isEmpty(this.scheduleid[0].Last_Name))
        {
          this.firstname = this.scheduleid[0].First_Name
        }
        else
        {
          this.firstname = this.scheduleid[0].First_Name + " " + this.scheduleid[0].Last_Name;
        }      
        this.college_name = this.scheduleid[0].College_Name;

        this.view_question_pdf();
      },
      err => {
        console.error(err);
      }
    );
    this.userDetails.getUserDetails(this.student_id.user_id, true).subscribe(
      (data) => {
        // console.log("this.data",data)
        // console.log("data.Datareturned[0].Image_URL",data.Datareturned[0].Image_URL)
        let imageUrlArray = data.Datareturned[0].Image_URL.split('@@@')
        this.imageUrl = imageUrlArray[0]
        this.imageUrlArray = data.Datareturned[0].Image_URL.split('@@@')
        this.imageUrlArray.shift()

      }) 

  }

  goToEvaluateScreen(row){
    console.log("row",row)
    const params = { User_Id: row.Id,Total_Score:row.Total_Score,Name:row.Name,College_Id:this.College_Id,College_Name:this.College_Name,Year_Id:this.Year_Id,Question_Set_Id:this.SelectedQuestionSetId,isEvaluated:this.isEvaluated,isCandidateEvaluated:row.Evaluated};
    console.log("params",params)
    this.router.navigate(['/manual_evaluation',params])
  }

  view_question_pdf() {
    this.studentdata=JSON.parse(sessionStorage.getItem('studentdata'));
    console.log("this.studdent_id**************",this.student_id,this.studentdata)
    this.fs.Questionpdf(this.student_id).subscribe(
      (data) => {

        console.log("data.results",data)
        this.scheduleid = data.sortedResults;
        // this.student_id.user_id = this.id
        // this.student_id.schedule_id = this.scheduleid[0].Id;
        for (var i = 0; i < this.scheduleid.length; i++) {
          MathJax.Hub.Config({
            showMathMenu: false,
            tex2jax: { inlineMath: [['$', '$'], ['\\(', '\\)']] },
            menuSettings: { zoom: "Double-Click", zscale: "150%" },
            CommonHTML: { linebreaks: { automatic: true } },
            "HTML-CSS": { scale: 100, linebreaks: { automatic: true, width: "container" } },
            SVG: { linebreaks: { automatic: true } }
          });
          setTimeout(() => {
            MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementsByClassName("answers")]);
          }, 6000)

        }
        this.questions_ready = true;

      },
      err => {
        console.error(err);
      }
    );


  }
  changeManualEvalCheckBox(event: any) {
    const isChecked = event.checked;

    if (isChecked) {
      console.log('Checkbox is checked');
      this.isSelectedForManualEval = true
      this.disableInterview = true;
      for(let i=0;i<this.studentDetails.length;i++){
        if(this.studentDetails[i][`Selected for Manual Evaluation`] === 'Yes'){
          this.filteredDetails.push(this.studentDetails[i])
        }
      }
      console.log("this.filter",this.filteredDetails)
      this.updateDataSourceBasedOnFilter(this.filteredDetails)

    } else {
      console.log('Checkbox is unchecked');
      this.isSelectedForManualEval = false
      this.disableInterview = false;
      this.updateDataSourceBasedOnFilter(this.studentDetails)
      this.filteredDetails = []

    }
  }

  changeShortlistedCheckBox(event:any){
    const isChecked = event.checked;

    if (isChecked) {
      console.log('Checkbox is checked changeShortlistedCheckBox');
      this.isShortlistedForInterview = true
      this.disableManualEval = true;

      for(let i=0;i<this.studentDetails.length;i++){
        if(this.studentDetails[i][`Shortlisted for interview`] === 'Yes'){
          this.filteredDetails.push(this.studentDetails[i])
        }
      }
      console.log("this.filter",this.filteredDetails)
      this.updateDataSourceBasedOnFilter(this.filteredDetails)
    } else {
      console.log('Checkbox is unchecked');
      this.isShortlistedForInterview = false
      this.disableManualEval = false;
      this.updateDataSourceBasedOnFilter(this.studentDetails)
      this.filteredDetails = []

    }
  }

  updateDataSourceBasedOnFilter(filteredArray){
    if(filteredArray.length == 0){
      console.log("filteredArray length is 0")
      this.displayTable = false
    }else{
      this.displayTable = true
    }
    console.log("filteredArray inside updateDataSourceBasedOnFilter",filteredArray)
    this.dataSource = new MatTableDataSource(filteredArray);
    this.dataSource.sort = this.sort;
      this.dataSource.sort.sort(<MatSortable>({ id: 'Total_Score', start: 'desc' }));
      setTimeout(() => this.dataSource.paginator = this.paginator);
  }

    //get candidate report, populate into excel sheet and save it in temp_report table(group_concat method)
    downloadFile() {
      this.report_details.College_Id = this.College_Id;
      this.report_details.Year_Id = this.Year_Id;
      this.report_details.Question_Set = this.SelectedQuestionSetId;
  
  
  
      console.log(this.report_details);
      this.reportservice.download_report(this.report_details).subscribe(
        (data) => {
  
          this.reportdetailss = data.results;
  
          this.download_csv();
  
        },
        err => {
          console.error(err);
        }
      );
    
    }
  
    //download data from temp_report table
    download_csv() {
      console.log("inside dowbload csv",this.dataSource.filteredData)
      // this.data=true;
      this.filteredIdsArray = []
      var filteredArray = this.dataSource.filteredData
      filteredArray.map(data =>{
        console.log("inside",data.Id)
        this.filteredIdsArray.push(data.Id)
      })
      console.log('filteredIdsArray',this.filteredIdsArray)      
      this.report_details.College_Id = this.College_Id;
      this.report_details.Year_Id = this.Year_Id;
      this.report_details.Question_Set = this.SelectedQuestionSetId;
  
  
  
  
      this.reportservice.download_csv(this.report_details,this.filteredIdsArray).subscribe(
        (data) => {
          var csv = '';
          data.results.forEach((row) => {
            
            // FIX: Replace newlines in the Report_Val string
            if (row.Report_Val) {
              row.Report_Val = row.Report_Val
                .replace(/\r\n/g, ' ')  // Replace Windows newlines
                .replace(/\n/g, ' ')    // Replace Unix newlines
                .replace(/\r/g, ' ');   // Replace Mac newlines
            }
            
            var array = Object.values(row);
            csv += array.join(',');
            csv += "\n";
          });

          var hiddenElement = document.createElement('a');
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'test_report.csv';
          hiddenElement.click();
        },
        err => {
          console.error(err);
        }
      );
    }


  
}

